import React, { useContext, useEffect, useState } from 'react';
import { IProps } from './types';
import {ReactComponent as SpacingIcon} from 'assets/svgs/spacing.svg';
import Tooltip from '@components/Tooltip';
import * as S from './styles';
import { ITextAttributes } from 'routes/private/Editor/types';
import { Context } from "routes/private/Editor/Context";
import { findElementById, findCommonAttributeValue } from "@utils/editor";
import ClickOutside from '@components/ClickOutside';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

const FontSpacingCommandOption : React.FC<IProps> = () => {
  let { editorStatus, data, onCommandChange} = useContext(Context);
  const [isSelected, setIsSelected]= useState(false);  
  const [letterSpacing, setLetterSpacing]= useState<number|undefined>(0);
  const [inputLetterSpacing, setInputLetterSpacing]= useState<string>();  
  const [lineHeight, setLineHeight]= useState<number|undefined>(1.2);
  const [inputLineHeight, setInputLineHeight]= useState<string>();  
  const startSpacingSlider = 0;
  const minSpacingSlider = -200;
  const maxSpacingSlider = 800;
  const startHeightSlider = 1.2;
  const minHeightSlider = 0.5;
  const maxHeightSlider = 2.5;

  useEffect(() => {
    const spacing = findCommonAttributeValue(editorStatus.selectedElementsId, data, "letterSpacing", "Text", editorStatus.textSelectionInformation);
    setLetterSpacing(spacing!==undefined?parseFloat(spacing):undefined);
    if (inputLetterSpacing !== "-") setInputLetterSpacing(spacing!==undefined?spacing:"");
    const height = findCommonAttributeValue(editorStatus.selectedElementsId, data, "lineHeight", "Text", editorStatus.textSelectionInformation);
    setLineHeight(height!==undefined?parseFloat(height):undefined);
    let changeInputLineHeight = true;
    if (height != undefined && inputLineHeight != undefined && parseFloat(height) == parseFloat(inputLineHeight)) {
      changeInputLineHeight = false;
    }
    if (changeInputLineHeight) setInputLineHeight(height!==undefined?height:"");
  }, [editorStatus.selectedElementsId.length, editorStatus.selectedElementsId[0], data, editorStatus.textSelectionInformation]);

  const SetLetterSpacing = (value: number|undefined, notSave?:boolean) => {  
    setLetterSpacing(value);
    onCommandChange("letterSpacing", value, undefined, undefined, notSave);          
  }

  const SetLineHeight = (value: number|undefined, notSave?:boolean) => {  
    setLineHeight(value);
    onCommandChange("lineHeight", value, undefined, undefined, notSave);          
  }

  const marks={
    1.2: {
      label:'1.2'
    }
  }

  const handleInputSpacingSlider = (e: any) => {
    const inputText = e.target.value;

    if(inputText==="" || inputText==="-" || (!isNaN(inputText) && parseFloat(inputText)<minSpacingSlider && parseFloat(inputText)>=Math.trunc(minSpacingSlider))) {
      SetLetterSpacing(undefined);
      setInputLetterSpacing(inputText);
    }

    if(!isNaN(inputText) && parseFloat(inputText)>=minSpacingSlider && parseFloat(inputText)<=maxSpacingSlider) {
      setInputLetterSpacing(inputText);
      SetLetterSpacing(parseFloat(inputText));
    }
  }

  const handleInputHeightSlider = (e: any) => {
    const inputText = e.target.value;

    if(inputText==="" || (!isNaN(inputText) && parseFloat(inputText)<minHeightSlider && parseFloat(inputText)>=Math.trunc(minHeightSlider))) {
      SetLineHeight(undefined);
      setInputLineHeight(inputText);
    }

    if(!isNaN(inputText) && parseFloat(inputText)>=minHeightSlider && parseFloat(inputText)<=maxHeightSlider && inputText.toString().length<=3) {
        SetLineHeight(parseFloat(inputText));
        setInputLineHeight(inputText);
    }
  }

  return (
    <S.Root>
      <ClickOutside onClickOutside={()=> setIsSelected(false)}>
        <Tooltip tip={"Text Spacing"} boxStyle={isSelected ? {display:'none'}:undefined}>
          <S.ButtonContainer onClick={()=> setIsSelected(!isSelected)} isSelected={isSelected}>
            <SpacingIcon/>
          </S.ButtonContainer>
        </Tooltip>
        <S.OptionsList style={{ display: isSelected ? "flex" : "none"}}>
          <S.optionContainer>
              <S.Label>
                Letter spacing
              </S.Label>
              <S.SliderContainer>
              <Slider
                min={minSpacingSlider}
                max={maxSpacingSlider}
                step={1}
                startPoint={startSpacingSlider}
                marks={[0]}
                value={letterSpacing!==undefined?letterSpacing:startSpacingSlider}
                onChange={(e)=> {SetLetterSpacing(e,true); setInputLetterSpacing(e.toString())}}
                onAfterChange={(e)=> {SetLetterSpacing(e); setInputLetterSpacing(e.toString())}}
                railStyle={{
                  height:1,
                  background: "#818181"
                  
                }}
                handleStyle={{
                  height: 10,
                  width: 10,                
                  marginTop: -4,
                  backgroundColor: "#c4c4c4",
                  border: 0
                }}
                trackStyle={{
                  height:1,
                  background: "none"
                }}
                dotStyle={{
                  border:0,
                  height:5,
                  width:5,
                  top:-2,
                  background: "#c4c4c4"

                }}
                
              />
              </S.SliderContainer>
              <S.InputSlider disabled={false}
                value={inputLetterSpacing!==undefined?inputLetterSpacing:""}
                onChange={handleInputSpacingSlider}
              ></S.InputSlider>
            </S.optionContainer>
          <S.optionContainer>
            <S.Label>
              Line spacing
            </S.Label>
            <S.SliderContainer>
            <Slider
                min={minHeightSlider}
                max={maxHeightSlider}
                step={0.1}
                startPoint={startHeightSlider}
                marks={marks}
                value={lineHeight!==undefined?lineHeight:startHeightSlider}
                onChange={(e)=> {SetLineHeight(e,true); setInputLineHeight(e.toString())}}
                onAfterChange={(e)=> {SetLineHeight(e); setInputLineHeight(e.toString())}}
                railStyle={{
                  height:1,
                  background: "#818181"
                  
                }}
                handleStyle={{
                  height: 10,
                  width: 10,    
                  marginTop: -4,
                  backgroundColor: "#c4c4c4",
                  border: 0
                }}
                trackStyle={{
                  background: "none"
                }}
                dotStyle={{
                  border:0,
                  height:5,
                  width:5,
                  top:-2,
                  background: "#c4c4c4"

                }}
              />
              </S.SliderContainer>
              <S.InputSlider disabled={false} 
                value={inputLineHeight!==undefined?inputLineHeight:""}
                onChange={handleInputHeightSlider}
              ></S.InputSlider>
            </S.optionContainer>
        </S.OptionsList>
      </ClickOutside>
    </S.Root>
  );
}

export default FontSpacingCommandOption;